let date = new Date();
let year = date.getFullYear();

export const TRANSACTIONSLIST = "This is a list of latest Transactions";
export const RESTAURANT = "Restaurant Booking App";
export const BOOTSTRAP = "Bootstrap Framework";
export const REACTBOOTSTRAP = "React & Bootstrap Framework";
export const GLASSMORPHISM = "Glassmorphism UI";
export const TAILWIND_REACT = "Tailwind & React";
export const VUE_TAILWIND = "Vue Js & Tailwind";
export const MULTIPURPOSE_TEMP = "Multipurpose Template";

export const CUSTOMERS_LABEL = "Latest Customers";
export const TOP_PRODUCTS = "Top Products";

export const OVERVIEW = "Overview";
export const MESSAGES = "Messages";
export const DOCS = "Docs";
export const COMPONENTS = "Components";

export const CREATED_BY = "Creado por";
export const FULL_YEAR = year;
